import {
  Avatar, colors, Divider, Drawer, Hidden, List, ListSubheader, Typography, Grid, InputBase
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router';
import avatar from 'src/assets/images/technician.png';
import NavItem from 'src/components/NavItem';
import { getUser } from 'src/utils/Common';
import { isProduction } from 'src/utils/contants';
import StartMenu from 'src/utils/storage/NavBarAdet';
import { useTranslation } from 'react-i18next';
import axios from 'src/utils/axiosCatalog';
import SearchIcon from '@material-ui/icons/Search';
import { fade } from '@material-ui/core/styles';
import { sc } from 'src/utils/Common';
import { getMenuForEmployee } from '../../../src/store/slices/userAuthoritySlice';
import { useDispatch } from 'react-redux';
const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  mobileDrawer: {
    width: 300,
  },
  desktopDrawer: {
    width: 300,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  navigation: {
    overflow: 'auto',
    padding: theme.spacing(0, 2, 2, 2),
    flexGrow: 1
  },
  profile: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  badge: {
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`
  },
  badgeDot: {
    height: 9,
    minWidth: 9
  },
  onlineBadge: {
    backgroundColor: colors.green[600]
  },
  awayBadge: {
    backgroundColor: colors.orange[600]
  },
  busyBadge: {
    backgroundColor: colors.red[600]
  },
  offlineBadge: {
    backgroundColor: colors.grey[300]
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  details: {
    marginLeft: theme.spacing(2)
  },
  moreButton: {
    marginLeft: 'auto',
    color: colors.blueGrey[200]
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.55),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.65),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '30ch',
      '&:focus': {
        width: '30ch',
      },
    },
  },
}));

function renderNavItems({
  // eslint-disable-next-line react/prop-types
  items, subheader, key, ...rest
}, klima_teknisyeni) {
  return (
    <List key={key}>
      {subheader && <ListSubheader disableSticky>{subheader}</ListSubheader>}
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, ...rest }, klima_teknisyeni),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({
  acc, pathname, item, depth = 0
}, klima_teknisyeni) {
  if (klima_teknisyeni && item.klima_teknisyeni_gizle && item.klima_teknisyeni_gizle) {
    return acc;
  }
  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={item.href}
        label={item.label}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={item.href}
        label={item.label}
        title={item.title}
      />
    );
  }

  return acc;
}
const klima_teknisyeni = false;
function NavBar({
  open,
  onClose,
  className,
  ...rest
}) {
  const Menu = StartMenu();
  const dispatch = useDispatch();


  const { t } = useTranslation(['Catalog']);
  const MenuCount = Menu.length;
  const classes = useStyles();
  const location = useLocation();
  const [Search, setSearch] = React.useState('');
  const [UserImageUrl, setUserImageUrl] = useState(!isProduction ? avatar : `https://yetkiliservis.arcelik.com/SchedulingQuota/TechnicianImage/${SessionUser?.TechnicianId}.png`);
  const [navConfig, setnavConfig] = React.useState([
    {
      subheader: t('Menus'),
      items: Menu
    }
  ]);
  const [navConfigAll, setnavConfigAll] = React.useState([
    {
      subheader: t('Menus'),
      items: Menu
    }
  ]);
  const SessionUser = getUser();

  useEffect(() => {

    var Data = [];
    dispatch(getMenuForEmployee(SessionUser.TechnicianId))
      .then((response) => {
        var Response = response.payload;
        if (Response?.length > 0) {
          Response.forEach((item) => {
            Data.push(item.MenuId);
          });

          var SearchDataMenu = Menu?.map((element) => {
            return {
              ...element,
              items: element.items?.filter((subElement) => Data.includes(subElement.id))
            }
          });

          // var SearchDataEnd = SearchDataMenu.filter((item) => item.items?.length > 0);

          setnavConfig([
            {
              subheader: t('Menus'),
              items: SearchDataMenu
            }
          ]);
          setnavConfigAll([
            {
              subheader: t('Menus'),
              items: SearchDataMenu
            }
          ]);


        }
      });

    // eslint-disable-next-line
  }, [location.pathname, MenuCount]);

  useEffect(() => {
    GetSiriusUserImage();
  }, [SessionUser.TechnicianId]);


  const GetSiriusUserImage = () => {
    const config = {
      responseType: 'blob',
    };

    axios.get(`/FileImportExport/SiriusUserImageDetail/${SessionUser.TechnicianId}`, config)
      .then((response) => {
        // openBlob(response.data, dosya.FileName);
        const fileURL = URL.createObjectURL(response.data);
        setUserImageUrl(fileURL);
      }).catch((error) => {

      });


  }

  const setSearchFind = (event) => {
    setSearch(event.target.value);
    var SearchData = navConfigAll[0].items.map((element) => {
      return {
        ...element,
        items: element.items?.filter((subElement) => sc(subElement.title, event.target.value))
      }
    });
    var SearchDataEnd = SearchData.filter((item) => item.items?.length > 0);





    var result = [
      {
        subheader: t('Menus'),
        items: SearchDataEnd
      }
    ];
    setnavConfig(result);

  }

  const content = (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <br />
      <Divider className={classes.divider} />
      <nav>
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            placeholder={t('lblSearchMenu')}
            autoFocus
            value={Search}
            // onKeyUp={(e) => setAnchorEl(e.currentTarget)}
            onChange={(event) => setSearchFind(event)}
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ 'aria-label': 'search' }}
          />
        </div>
      </nav>
      <Divider className={classes.divider} />
      <nav className={classes.navigation}>
        {navConfig.map((list) => renderNavItems({
          items: list.items,
          subheader: list.subheader,
          pathname: location.pathname,
          key: list.subheader
        }, klima_teknisyeni))}
      </nav>
      <Divider className={classes.divider} />
      <div className={classes.profile}>
        <Grid container spacing={1}>
          <Grid item xs={3} xl={3}>
            <Avatar
              alt="Person"
              className={classes.avatar}
              src={UserImageUrl}
            />
          </Grid>

          <Grid item xs={9} xl={9}>
            <Typography
              variant="h6"
              color="textPrimary"
            >
              {`${SessionUser.FirstName} ${SessionUser.LastName}`}
            </Typography>
            <Typography variant="body2">
              {SessionUser.ServiceShopCode}
              {' '}
              {SessionUser.ServiceShopName}
              {' '}
              {SessionUser.TopServiceShopName}
            </Typography>
          </Grid>
        </Grid>
      </div>
    </div>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{
            paper: classes.mobileDrawer
          }}
          onClose={onClose}
          open={open}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{
            paper: classes.desktopDrawer
          }}
          open={open}
          onClose={onClose}
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
}

NavBar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

export default NavBar;
